type ParamsToMakeSchema = {
  articleName: string
  categoryName: string
  lastReviewData: string
  articleUrl: string
  imageUrl: string
}

export const makeArticleSchemaJsonLD = ({
  categoryName,
  lastReviewData,
  articleUrl,
  articleName,
  imageUrl
}: ParamsToMakeSchema) => {
  return {
    '@context': 'http://schema.org',
    '@type': 'MedicalWebPage',
    about: {
      '@type': 'MedicalCondition',
      name: [categoryName]
    },
    name: articleName,
    image: imageUrl,
    url: articleUrl,
    mainContentOfPage: ['Diagnosis', 'Treatment'],
    audience: 'http://schema.org/Patient',
    // drug: [
    //   {
    //     '@type': 'Drug',
    //     nonProprietaryName: 'propanaolol',
    //     alternateName: 'Innopran'
    //   },
    //   {
    //     '@type': 'Drug',
    //     nonProprietaryName: 'atenolol',
    //     alternateName: 'Tenormin'
    //   }
    // ],
    lastReviewed: lastReviewData,
    specialty: 'http://schema.org/Osteopathic'
  }
}
